export const inbox = {
  titles: {
    inbox: "Skrzynka odbiorcza",
    unifiedInbox: "Skrzynka odbiorcza w jednym miejscu",
  },
  subtitles: {
    manageMessages: "Zarządzaj wiadomościami ze swoich kanałów rezerwacji",
    unifiedDesc:
      "Tutaj znajdują się wszystkie rozmowy z gośćmi, niezależnie od tego, czy piszą z Airbnb, Booking, czy z innego kanału.",
    subscribeHint:
      "Wykup subskrypcję, aby aktywować skrzynkę odbiorczą i uprościć komunikację.",
    planOnly:
      "Ten moduł jest dostępny wyłącznie w planach {plans}.",
  },
  states: {
    notInstalledTitle: "Moduł wiadomości nie jest zainstalowany",
    notInstalledDesc:
      "Zainstaluj moduł wiadomości, aby połączyć się ze swoimi kanałami rezerwacji.",
    noChannelsTitle: "Brak podłączonych kanałów",
    noChannelsDesc:
      "Aby korzystać z modułu wiadomości, musi być podłączony co najmniej jeden kanał (Booking.com, Airbnb).",
    noAccessTitle: "Brak dostępu do modułu wiadomości",
  },
  actions: {
    installModule: "Zainstaluj moduł wiadomości",
    configureChannel: "Skonfiguruj kanał",
  },
  toasts: {
    connectChannelRequiredTitle: "Wymagane połączenie",
    connectChannelRequiredBody:
      "Podłącz co najmniej jeden kanał rezerwacji, aby zainstalować moduł wiadomości.",
  },
  errors: {
    notFoundPropertyOrUser: "Nie znaleziono obiektu lub użytkownika.",
    channelConnectGeneric:
      "Błąd podczas łączenia z kanałem. Spróbuj ponownie.",
    generateTokenError: "Błąd podczas generowania tokenu",
  },
};
